<template>
  <v-dialog v-model="visible" max-width="700px">
    <v-card>
      <v-card-title class="text-uppercase">{{ titulo }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-select
                class="mt-2"
                :items="gestiones"
                label="Gestion"
                item-text="numero"
                item-value="id"
                v-model="form.gestion_id"
                placeholder=" "
                outlined
                dense
                hide-details
                :disabled="!!this.form?.id"
                :item-disabled="(item) => item.numero != new Date().getFullYear()">
              </v-select>

              <small v-for="error in errores.gestion_id" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-text-field
                class="my-1"
                label="Nombre"
                v-model="form.nombre"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-select
                :items="estadoItems"
                label="Estado"
                v-model="form.estado"
                placeholder=" "
                outlined
                dense
                hide-details />

              <small v-for="error in errores.estado" :key="error" class="text-danger">{{ error }}</small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar()"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="validar()"> Guardar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import PresupuestoGastoServices from '../services/index';
import { formatearErrores } from '../utils';
import GetGestionesMixin from '../mixins/get-gestiones-mixin';
import ModalFormMixin from '../mixins/modal-form-mixin';

export default {
  mixins: [GetGestionesMixin, ModalFormMixin],
  data() {
    return {
      estadoItems: [
        { text: 'ACTIVO', value: 1 },
        { text: 'INACTIVO', value: 0 },
      ],
    };
  },
  watch: {
    'form.nombre': function () {
      this.errores.nombre = [];
    },
    'form.gestion_id': function () {
      this.errores.gestion_id = [];
    },
    'form.estado': function () {
      this.errores.estado = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        sede_id: this.$store.state.CARGO.sede.id,
        user_id: this.$store.state.DATA_USER.id,
        sede: this.$store.state.CARGO.sede.nombre,
        user: `${this.$store.state.DATA_USER.nombres} ${this.$store.state.DATA_USER.pri_apellido} ${this.$store.state.DATA_USER.seg_apellido}`,
        tipo: this.tipo,
        estado: 1,
        nombre: null,
        gestion_id: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        sede_id: data.sede_id,
        user_id: data.user_id,
        sede: data.sede,
        user: data.user,
        tipo: data.tipo,
        estado: data.estado,
        nombre: data.nombre,
        gestion_id: data.gestion_id,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);

      this.obtenerGestiones();
    },
    async registrar() {
      this.guardar();
    },
    async editar() {
      this.guardar();
    },
    async guardar() {
      this.enviando = true;
      this.errores = [];

      try {
        let response = null;

        if (this.form?.id) {
          response = await PresupuestoGastoServices.update(this.form.id, this.form);
        } else {
          response = await PresupuestoGastoServices.store(this.form);
        }

        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>